import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-superuser-reports-memberinout',
  templateUrl: './superuser-reports-memberinout.component.html',
  styleUrls: ['./superuser-reports-memberinout.component.scss']
})
export class SuperuserReportsMemberinoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
